/**
 * Drag Horizontal
 * @namespace DragHorizontal
 */

/* Plugins */

export default class DragHorizontal {
  /**
   * Dragging element horizontal to trigger function
   * @param {DOM} element
   * @param {Object} options handle, callback
   */
  static init(el, options = { handle: null, threshold: null, callback: () => {} }) {
    let pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0,
      threshold = options.threshold || el.clientWidth * 0.25

    console.log(options.handle, 'handle', el)
    const handle = options.handle

    const dragMouseDown = (e) => {
      console.log('mousedown', e)
      e = e || window.event
      // e.preventDefault();
      // get the mouse cursor position at startup:
      const clientX = e.type == 'touchstart' ? e.touches[0].clientX : e.clientX

      pos4 = clientX
      pos1 = clientX
      document.onmouseup = closeDragElement
      document.ontouchend = closeDragElement
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag
      document.ontouchmove = elementDrag
      //   document.body.classList.toggle('overflow-hidden', true)
      el.classList.toggle('notransition', true)

      const dragSliders = Array.from(document.querySelectorAll('.dragSlideLeftCont'))

      /**
       * Reset other sliders
       */
      dragSliders.forEach((item) => {
        if (item != el) item.style.left = null
      })
    }

    const elementDrag = (e) => {
      e = e || window.event
      // e.preventDefault();
      // calculate the new cursor position:
      const clientX = e.type == 'touchmove' ? e.touches[0].clientX : e.clientX
      // console.log('element drag', e)

      pos2 = pos4 - clientX
      pos4 = clientX
      pos3 = el.offsetLeft - pos2
      el.style.left = pos3 + 'px'
      console.log('pos1', pos3, pos1, pos4)
      // set the element's new position:
      //   if (pos4 > pos1) {
      //     el.style.left = pos3 + 'px'
      //   }
    }

    const closeDragElement = () => {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null
      document.ontouchend = null
      document.onmousemove = null
      document.ontouchmove = null
      document.body.classList.toggle('overflow-hidden', false)
      el.classList.toggle('notransition', false)

      /* Reset or close */
      console.log(
        Math.abs(pos3) > threshold,
        'post reset',
        Math.abs(pos3),
        options.threshold,
        el.clientWidth,
        el.clientWidth * 0.25
      )

      if (pos3 < 0 && Math.abs(pos3) > threshold) {
        el.style.left = -threshold + 'px'
        console.log('reveal ', true)
        options.callback(true)
      } else {
        el.style.left = null
        console.log('reveal ', false)
        /* Callback */
        options.callback(false)
      }
    }

    /* Add event listener */
    if (handle) {
      /* if present, the header is where you move the DIV from:*/
      handle.onmousedown = dragMouseDown
      handle.ontouchstart = dragMouseDown
    }
  }
}
